<template>
  <div>
    <el-form
      class="login-form form-custom reset-form-wrap"
      :class="{ 'mgb-reset': step }"
      ref="form"
      label-position="top"
      label-width="80px"
      @submit.native.prevent
      :hide-required-asterisk="true"
      :rules="rules"
      :model="form"
    >
      <el-form-item
        :label="!step ? context.langObj['accountTitle'] : ''"
        class="form-item-primary"
        prop="user_name"
      >
        <!-- 邮箱 -->
        <BaseInput
          v-if="context.type === 'email'"
          v-model="form.user_name"
          :disabled="accountDisabled"
          @keyup.enter.native="next"
          :validate-event="Boolean(form.user_name)"
          :placeholer="context.langObj['accountLabel']"
        >
        </BaseInput>

        <!-- 电话号码 -->
        <template v-if="context.type === 'phone'">
          <BaseInput
            v-if="step === 0"
            v-model="form.user_name"
            :autofocus="!isMobile"
            :disabled="accountDisabled"
            @keyup.enter.native="next"
            :validate-event="Boolean(form.user_name)"
            :placeholer="context.langObj['accountLabel']"
          >
            <template #prepend>
              <el-select
                v-model="form.pretel"
                style="width: 100px"
                :disabled="true"
                :placeholer="context.langObj['accountLabel']"
              >
                <el-option
                  v-for="item in preTelList"
                  :value="item"
                  :label="'+' + item"
                  :key="'+' + item.toString()"
                  >+ {{ item }}</el-option
                >
              </el-select>
            </template>
          </BaseInput>
          <div v-if="step === 1" class="input-custom-disabled">
            +{{ form.pretel }}&nbsp;&nbsp;{{ form.user_name | phoneFormat }}
          </div>
        </template>
      </el-form-item>

      <template v-if="step === 1">
        <el-form-item class="form-item-primary" prop="verification_code">
          <BaseInput
            v-model="form.verification_code"
            :maxlength="smsLength"
            @focus="changeCode"
            :validate-event="Boolean(form.verification_code)"
            :placeholer="$t('login.resetPassword.verificationCode')"
          >
            <template #btn>
              <VerificationCode
                theme="primary"
                ref="verification"
                @click="sendCode"
                :account="form.user_name"
                :from="'reset'"
              />
            </template>
            <template #prefix>{{
              $t('login.resetPassword.verificationCode')
            }}</template>
          </BaseInput>
        </el-form-item>
        <el-form-item
          class="form-item-primary"
          prop="password"
          :class="{ 'higher-height': $i18n.locale === 'en' }"
        >
          <BaseInput
            v-model.trim="form.password"
            type="password"
            :validate-event="Boolean(form.password)"
            :placeholer="$t('login.resetPassword.enterNewPassword')"
          />
        </el-form-item>
        <el-form-item class="form-item-primary" prop="re_enter_password">
          <BaseInput
            v-model.trim="form.re_enter_password"
            @keyup.enter.native="submit"
            type="password"
            :validate-event="Boolean(form.re_enter_password)"
            :placeholer="$t('login.resetPassword.reEnterNewPassowrd')"
          />
        </el-form-item>
      </template>
    </el-form>
    <el-button class="button-custom" v-if="step === 0" @click="next">{{
      $t('login.resetPassword.next')
    }}</el-button>
    <el-button class="button-custom" v-if="step === 1" @click="submit">{{
      $t('login.resetPassword.resetPassword')
    }}</el-button>
  </div>
</template>

<script>
import BaseInput from '@/components/common/BaseInput.vue'
import VerificationCode from '@/components/login/VerificationCode.vue'
import settings from '@/settings.js'
import { checkEmail, checkPhone, checkPassword } from '@/utils/validate-rules'
import _throttle from 'lodash/throttle'
import { mapGetters } from 'vuex'
import store from '@/store'
export default {
  name: '',
  props: {
    context: {
      type: Object,
      require: true,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      form: {
        user_name: '',
        pretel: '86',
      },
      isWrong: false,
      preTelList: settings.preTelList,
      registered: false, // 是否已注册，默认未注册；因需要确认已注册才可以进入下一个页面
    }
  },

  components: { BaseInput, VerificationCode },

  computed: {
    ...mapGetters(['currentAccount']),
    account() {
      const _step = this.currentAccount
      if (_step !== 'account') {
        if (this.context.type === 'email') {
          if (checkEmail(_step)) {
            return _step
          }
        } else if (this.context.type === 'phone') {
          if (checkPhone(_step)) {
            return _step
          }
        }
      }
      return ''
    },
    autoSend() {
      return this.step === 1
    },
    rules() {
      return {
        user_name: [
          {
            required: true,
            message: {
              email: this.$t('login.resetPassword.ruleEmail'),
              phone: this.$t('login.resetPassword.ruleMobilePhone'),
            }[this.context.type],
          },
          {
            validator: async (rule, value, callback) => {
              if (this.context.type === 'phone') {
                if (checkPhone(value)) {
                  try {
                    let data = await store.dispatch('CheckUser', {
                      user_name: value,
                    })
                    if (data.data === true) {
                      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                      this.registered = false
                      return callback(
                        new Error(this.$t('login.register.notExists'))
                      )
                    } else {
                      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                      this.registered = true
                      return callback()
                    }
                  } catch (error) {
                    return callback()
                  }
                  // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                }
              } else if (this.context.type === 'email') {
                if (checkEmail(value.toLowerCase())) {
                  try {
                    let data = await store.dispatch('CheckUser', {
                      user_name: value,
                    })
                    if (data.data === true) {
                      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                      this.registered = false
                      return callback(
                        new Error(this.$t('login.register.notExists'))
                      )
                    } else {
                      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                      this.registered = true
                      return callback()
                    }
                  } catch (error) {
                    return callback()
                  }
                }
              }

              return callback(
                new Error(this.context.langObj['accountRequireLabel'])
              )
            },
            trigger: 'blur',
          },
        ],
        verification_code: [
          {
            required: true,
            message: this.$t('login.resetPassword.labelCode'),
          },
          {
            min: 4,
            message: this.$t('login.resetPassword.labelCode'),
          },
          {
            validator: (rule, value, callback) => {
              if (this.isWrong) {
                callback(
                  new Error(this.$t('login.loginPage.wrongSecurityCode'))
                )
              } else {
                callback()
              }
            },
          },
        ],
        password: [
          {
            required: true,
            message: this.$t('login.resetPassword.enterNewPassword'),
          },
          {
            validator: (rule, value, callback) => {
              if (!checkPassword(value)) {
                callback(
                  new Error(this.$t('login.resetPassword.showPasswordRules'))
                )
              } else {
                callback()
              }
            },
            trigger: ['blur'],
          },
        ],
        re_enter_password: [
          {
            required: true,
            message: this.$t('login.resetPassword.reEnterNewPassowrd'),
          },
          {
            validator: (rule, value, callback) => {
              if (value === this.form.password) return callback()

              return callback(
                new Error(this.$t('login.resetPassword.noMatchPassword'))
              )
            },
            trigger: ['blur'],
          },
        ],
      }
    },
    accountDisabled() {
      return this.step === 1
    },
    step() {
      const index = settings.resetPasswordRouterParams.indexOf(
        this.$route.params.step
      )
      return index === -1 ? 0 : index
    },
    smsLength() {
      return store.state.smsLength
    },
  },
  created() {
    // 如果通过跳转进入而为填写邮箱/手机号，应当返回填写
    if (!this.form.user_name && this.step === 1) {
      this.$router.replace({
        path: '/cim/reset_password/' + this.context.type + '/account/',
        query: { ...this.$route.query },
      })
      return
    }

    this.initAccount()
  },
  methods: {
    changeCode() {
      this.isWrong = false
    },
    initAccount() {
      if (this.account) {
        this.form.user_name = this.account
      }
    },
    sendCode() {
      this.$refs['verification'].send('reset')
    },
    clearDetail() {
      this.form.verification_code = ''
      this.form.password = ''
      this.form.re_enter_password = ''
    },
    submit: _throttle(
      function () {
        this.$refs['form'].validate(async (valid) => {
          try {
            if (valid) {
              const { user_name, password, verification_code } = this.form
              const params = {
                user_name,
                password,
                verification_code,
              }

              let result
              if (this.context.type === 'phone') {
                result = await this.$api.login.ResetPasswordByPhone(params)
              } else if (this.context.type === 'email') {
                result = await this.$api.login.ResetPasswordByEmail(params)
              }

              const data = result
              if (data.code === 0) {
                this.$message({
                  type: 'success',
                  message: data.data,
                  duration: 1500,
                  onClose: () => {
                    this.$router.replace({
                      path: '/cim/',
                      query: { ...this.$route.query },
                    })
                  },
                })
              }
            }
          } catch (error) {
            console.log(error, 'error tips')
            if (error.code === 11010) {
              this.isWrong = true
              this.$refs['form'].validateField('verification_code')
            }
          }
        })
      },
      500,
      { trailing: false }
    ),
    next() {
      this.$refs['form'].validate((valid) => {
        if (valid && this.registered) {
          this.$router.replace({
            path: '/cim/reset_password/email/detail/',
            query: { ...this.$route.query },
          })
          // 自动发送验证码
          this.$nextTick(function () {
            this.sendCode()
          })
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.reset-form-wrap {
  margin-top: 44px;
  margin-bottom: 140px;
}
.mgb-reset {
  margin-top: 12px;
  margin-bottom: 0;
}
</style>
